export const languageDefaults = {
  defaultLanguageCode: "en",
  supportedLanguageCodes: ["en", "ro", "fr", "de", "es"]
};
